import type { CityConfig } from "../city-template/types";

export const seattleConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Seattle",
  state: "Washington",
  stateAbbr: "WA",
  slug: "seattle",
  route: "/cities/seattle",
  title: "Emergency Passport Seattle WA | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Seattle, Washington — as fast as 24 hours. Fast passport renewal and new passport applications for Seattle, Bellevue, Tacoma, Redmond, and all Puget Sound residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Seattle, WA",
  heroSubtitle: "Seattle travelers — from Amazon and Microsoft professionals to University of Washington faculty to Pacific Rim families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of King County and the Puget Sound region.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Seattle%20Washington%20downtown%20skyline%20with%20the%20Space%20Needle%2C%20Puget%20Sound%20waterfront%2C%20modern%20skyscrapers%20mixed%20with%20historic%20Pike%20Place%20Market%2C%20lush%20evergreen%20forests%20surrounding%20the%20city%2C%20warm%20golden%20afternoon%20sunlight%2C%20Pacific%20Northwest%20city%20atmosphere%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=seattle-hero-001&orientation=landscape",
  heroImageAlt: "Seattle Washington downtown skyline with Space Needle and Puget Sound waterfront",
  geoPosition: "47.6062;-122.3321",
  geoPlacename: "Seattle, Washington",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "Visit in person — Seattle's own passport agency at 915 2nd Ave Suite 500",
  },
  nearbyCitiesZips: [
    { name: "Seattle", zips: "98101, 98102, 98103, 98104, 98105, 98106, 98107, 98108, 98109, 98110, 98112, 98115, 98116, 98117, 98118, 98119, 98121, 98122, 98125, 98126, 98133, 98134, 98136, 98144, 98146, 98148, 98154, 98158, 98164, 98168, 98174, 98177, 98178, 98188, 98195, 98199" },
    { name: "Bellevue", zips: "98004, 98005, 98006, 98007, 98008, 98009" },
    { name: "Tacoma", zips: "98401, 98402, 98403, 98404, 98405, 98406, 98407, 98408, 98409, 98411, 98413, 98416, 98418, 98421, 98422, 98424, 98444, 98445, 98446, 98447, 98448, 98464, 98465, 98466, 98467, 98493" },
    { name: "Redmond", zips: "98052, 98053, 98073" },
    { name: "Kirkland", zips: "98033, 98034, 98083" },
    { name: "Renton", zips: "98055, 98056, 98057, 98058, 98059" },
    { name: "Federal Way", zips: "98003, 98023, 98063, 98093" },
    { name: "Auburn", zips: "98001, 98002, 98092, 98071, 98093" },
    { name: "Kent", zips: "98030, 98031, 98032, 98035, 98042, 98064" },
    { name: "Shoreline", zips: "98133, 98155, 98160, 98177" },
    { name: "Burien", zips: "98146, 98148, 98166, 98168" },
    { name: "Issaquah", zips: "98027, 98029, 98075" },
    { name: "Mercer Island", zips: "98040" },
    { name: "Sammamish", zips: "98074, 98075" },
    { name: "Bothell", zips: "98011, 98012, 98021, 98041" },
    { name: "Lynnwood", zips: "98036, 98037, 98046, 98087" },
    { name: "Edmonds", zips: "98020, 98026" },
    { name: "Des Moines", zips: "98148, 98158, 98198" },
    { name: "SeaTac", zips: "98148, 98158, 98168, 98188, 98198" },
    { name: "Tukwila", zips: "98108, 98138, 98168, 98178, 98188" },
    { name: "Bainbridge Island", zips: "98110" },
    { name: "Vashon Island", zips: "98070" },
    { name: "West Seattle", zips: "98106, 98116, 98126, 98136, 98146" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Seattle Passport Agency — no cross-country travel required" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-ship-line", title: "Cruise & Pacific Rim Hub", desc: "Alaska cruise capital, Asia-Pacific corporate travel, Boeing global manufacturing — we understand Seattle's travel DNA" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any Puget Sound location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Bellevue, WA", route: "/cities/bellevue" },
    { name: "Emergency passport help in Tacoma, WA", route: "/cities/tacoma" },
    { name: "Urgent passport services in Spokane, WA", route: "/cities/spokane" },
    { name: "Washington passport services overview", route: "/states/washington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Seattle from our local office at 5608 17th Avenue NW in the Ballard neighborhood. Visit us by appointment, or use our courier pickup throughout Seattle and the Puget Sound region.",
  fpcOfficeDistance: "5608 17th Avenue NW — Seattle (Ballard)",
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Seattle and the Puget Sound region. From Amazon's South Lake Union campus and Microsoft's Redmond headquarters to the Port of Seattle's cruise terminals — the busiest in the nation for Alaska voyages — we serve a region whose passport needs are driven by tech innovation, global manufacturing, and the world's largest cruise market. When a Microsoft PM gets called to Bangalore on 5 days notice or a family discovers their passports expired 3 days before an Alaska cruise, they call us.",
  nearbyCitiesIntro: "We serve Seattle and all nearby communities including Bellevue, Tacoma, Redmond, Kirkland, Renton, Federal Way, Auburn, Kent, Shoreline, Burien, Issaquah, Mercer Island, Sammamish, Bothell, Lynnwood, Edmonds, Des Moines, SeaTac, Tukwila, Bainbridge Island, and Vashon Island.",
  howItWorksIntro: "Most Seattle travelers complete everything online and ship documents overnight. No need to navigate downtown traffic — our couriers handle the Seattle Passport Agency directly.",
  mistakesIntro: "Seattle is the Pacific Northwest's largest international travel hub with significant tech corporate travel from Amazon and Microsoft, Boeing's global manufacturing operations, the nation's busiest cruise market, and a deeply international population with strong Asia-Pacific ties. Here are the most common passport mistakes we see.",
  testimonialsIntro: "Seattle travelers — from Amazon principals to UW researchers to Alaska cruise families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Seattle, WA? Here are the most common ones we hear from Puget Sound travelers.",
  statePageRoute: "/states/washington",
  statePageName: "Washington",
  servicesIntro: "Whether you need a renewal before an Alaska cruise from Pier 66, an emergency passport for a Microsoft Build conference in Seattle's sister city of Kobe, or a first-time passport for a Boeing engineer deploying to the 787 assembly line in Charleston — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.dol.wa.gov",
  dmvLabel: "Washington DOL — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — local advantage", "No downtown parking or traffic hassle", "Perfect for tech and corporate travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — local advantage", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must visit Seattle Passport Agency downtown", "Full day commitment — parking and downtown traffic"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "SEA flight to Tokyo in 3 days? Alaska cruise boarding in 48 hours? Our emergency courier service submits via the Seattle Passport Agency downtown — as fast as 24 hours for Puget Sound travelers.",
      bullets: ["As fast as 24 hours", "Seattle Passport Agency — local courier advantage", "Cruise and corporate travel expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Puget Sound residents renew fast — no agency visit required. Perfect for Amazon teams, Microsoft engineers, and Boeing professionals.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Puget Sound residents through every step with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Left your passport at a Capitol Hill coffee shop? Bag stolen from your car in Belltown? We guide you through DS-64 and replacement fast.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We help Seattle and Eastside families navigate the process for their kids.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Amazon and Microsoft executives, Boeing global supply chain managers, and tech consultants traveling while primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Water damage from kayaking on Lake Union? Coffee-soaked from a Capitol Hill café? We guide Puget Sound residents through damaged passport replacement fast.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for Seattle-to-Vancouver weekend trips and Alaska cruise identification.",
      bullets: ["Wallet-size convenience", "Vancouver BC weekend trips", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Seattle WA", description: "Urgent passport processing for Seattle Washington travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Seattle WA", description: "Fast passport renewal for Seattle Washington residents with a previously-issued passport." },
    { name: "First-Time Passport Seattle WA", description: "New passport application services for Seattle Washington residents applying for their first passport." },
    { name: "Child Passport Seattle WA", description: "Minor passport services for Seattle Washington families with children under 16." },
    { name: "Name Change Passport Seattle WA", description: "Passport name correction after marriage, divorce, or legal name changes for Seattle residents." },
    { name: "Second Passport Seattle WA", description: "Second passport services for Seattle tech executives and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Jennifer M.",
      location: "Seattle, WA",
      rating: 5,
      text: "Alaska cruise in 6 days and my passport was expired. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store on Capitol Hill and the whole process was seamless. Outstanding.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "David K.",
      location: "Bellevue, WA",
      rating: 5,
      text: "Microsoft offsite in Hyderabad with 8 days notice. Four passports — two adult renewals and two first-time for kids. All done in 5 days. The team handled every application in parallel like clockwork.",
      service: "Family Passport Bundle",
    },
    {
      name: "Sarah L.",
      location: "Redmond, WA",
      rating: 5,
      text: "Conference in Singapore with 10 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. The courier service is an absolute game-changer for the Eastside.",
      service: "Emergency Passport",
    },
    {
      name: "Michael T.",
      location: "Seattle, WA",
      rating: 5,
      text: "Lost my passport the week before a UW study abroad semester in Spain. Fast Passport Center replaced it in 48 hours. As a student, I couldn't afford to miss my program — they saved my semester.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "sea-1",
      name: "Seattle Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "301 Union St",
      city: "Seattle",
      state: "WA",
      zip: "98101",
      phone: "(206) 442-7600",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Seattle, near Pike Place Market",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary downtown Seattle acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown office workers and transit riders.",
      icon: "ri-mail-line",
    },
    {
      id: "sea-2",
      name: "Ballard Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5604 22nd Ave NW",
      city: "Seattle",
      state: "WA",
      zip: "98107",
      phone: "(206) 782-2470",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Ballard, northwest Seattle",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Ballard, Fremont, and north Seattle residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "sea-3",
      name: "West Seattle Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4737 Fauntleroy Way SW",
      city: "Seattle",
      state: "WA",
      zip: "98116",
      phone: "(206) 935-3904",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Seattle, Alki Beach area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves West Seattle, Alki, and Fauntleroy communities. Good alternative for west-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "sea-4",
      name: "King County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "516 3rd Ave, Room W-105",
      city: "Seattle",
      state: "WA",
      zip: "98104",
      phone: "(206) 477-3080",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Seattle Courthouse",
      website: "https://www.kingcounty.com/depts/courts/clerk.aspx",
      websiteLabel: "King County Clerk",
      notes: "County Clerk passport acceptance in the downtown courthouse. Extended hours compared to post office. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
    {
      id: "sea-5",
      name: "University Station Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4333 Brooklyn Ave NE",
      city: "Seattle",
      state: "WA",
      zip: "98105",
      phone: "(206) 543-2700",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "University District, near UW campus",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for University of Washington students, faculty, and staff. Near the U-District light rail station.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown Seattle parking and traffic", fpc: "No — ship from your location" },
    { feature: "Alaska Cruise Expertise", agency: "No cruise-specific guidance", fpc: "Full Alaska cruise documentation knowledge" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Corporate Travel Ready", agency: "No — generic government process", fpc: "Amazon, Microsoft, Boeing travel timelines understood" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-ship-line",
      title: "Alaska Cruise Passport Discovery at Check-In",
      description: "Seattle is the #1 Alaska cruise departure port in the United States. Many cruise passengers book 6–12 months ahead and only discover expired passports at Pier 66 check-in. Cruise lines require 6 months validity — start renewal when you book, not when you pack.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute for Tech Travel",
      description: "Amazon and Microsoft international travel is frequently booked 1–2 weeks out. Standard passport processing takes 8–11 weeks. Expedited courier service is essential for Seattle's tech workforce.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services on Capitol Hill or in the University District sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-global-line",
      title: "Asia 6-Month Rule Surprise",
      description: "Seattle's Asia-Pacific connections mean many travelers head to Japan, China, and Southeast Asia — all of which require 6 months of passport validity beyond the stay. A passport with 5 months left is effectively expired for Asia travel.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Vancouver BC Weekend Trip Assumptions",
      description: "Many Seattleites treat Vancouver like a weekend neighborhood — but it's an international border crossing. A valid passport or passport card is mandatory. Expired passports cannot be used at the Peace Arch or Pacific Highway crossings.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Seattle Post Office appointments fill during summer cruise season and academic conference periods. Book 2–3 weeks ahead for acceptance facility visits — especially May through September.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your desk at Amazon, Microsoft, or your home in Ballard." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance — cruise, corporate, or family travel." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Seattle clients drop at a UPS Store or FedEx Office across the Puget Sound region." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Our registered courier submits to the Seattle Passport Agency — leveraging the local agency advantage without the downtown traffic and parking nightmare." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Seattle, WA?", a: "Fast Passport Center offers emergency passport processing in Seattle in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — downtown and locally accessible." },
    { q: "Can I get a passport before my Alaska cruise from Seattle?", a: "Absolutely. Seattle is the #1 Alaska cruise departure port in the U.S. We regularly help cruise passengers with emergency and expedited passports when they discover expired documents just before departure. As fast as 24–48 hours for cruise emergencies." },
    { q: "Does Seattle have its own passport agency?", a: "Yes — the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) serves travelers with confirmed travel within 14 days and requires appointments. Our courier service leverages this local agency for Puget Sound clients." },
    { q: "Can you help with Amazon or Microsoft corporate travel passports?", a: "Yes. We regularly assist Amazon, Microsoft, Boeing, and other Puget Sound employers with expedited passports for international business travel. We understand short-notice booking windows and can process team batches simultaneously." },
    { q: "Can I use a passport card to drive to Vancouver BC?", a: "Yes — the passport card is valid for land and sea crossings to Canada, Mexico, and the Caribbean. It's ideal for Seattle-to-Vancouver weekend trips. We expedite passport card applications with the same courier service as passport books." },
    { q: "What airport do Seattle travelers use for international flights?", a: "Seattle-Tacoma International Airport (SEA) is the primary airport. SEA offers nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines maintain major hubs here with extensive international service." },
    { q: "How much does an expedited passport cost in Seattle, WA?", a: "Government fees are fixed: $130 for an adult passport book plus a $60 expedite fee. Our service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Seattle?", a: "Walgreens, CVS, and Bartell Drugs stores throughout Seattle offer passport photos. UPS Store and FedEx Office locations also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve University of Washington students?", a: "Yes. We serve UW students, faculty, and staff — we understand academic conference schedules and study abroad deadlines. The University Station Post Office on Brooklyn Ave is the nearest acceptance facility." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Seattle Residents",
    intro: "Seattle's unique position as America's Alaska cruise capital, a global tech hub, and the Pacific Northwest's international gateway creates travel patterns that demand fast, reliable passport processing. Here's what Puget Sound travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "SEA — Seattle-Tacoma International Airport",
        subtitle: "Alaska Airlines & Delta Air Lines hub — 50+ international destinations",
        description: "Sea-Tac handles 50+ million passengers annually with nonstop flights to Tokyo, Seoul, London, Amsterdam, Dubai, and 50+ international destinations. Alaska Airlines' growing international network and Delta's trans-Pacific hub mean Puget Sound travelers have direct access to Asia and Europe. The airport's rapid international expansion creates regular passport urgencies — especially among tech workers booking last-minute Asia routes.",
        tip: "Alaska Airlines frequently launches new international routes from SEA. When a new Tokyo or Seoul route is announced, there's always a surge of bookings — and a surge of passport renewal needs. Check your passport validity now, not when the new route launches.",
      },
      {
        icon: "ri-ship-line",
        title: "Port of Seattle — America's Alaska Cruise Capital",
        subtitle: "Pier 66 and Pier 91 — 1.5+ million cruise passengers annually",
        description: "The Port of Seattle is the busiest cruise port on the West Coast and the primary departure point for Alaska cruises. Pier 66 (Bell Street) and Pier 91 (Smith Cove) handle major cruise lines including Holland America, Princess, Norwegian, Royal Caribbean, and Celebrity. The Alaska cruise season runs May through September, and every season we see hundreds of travelers discover expired or nearly-expired passports at the terminal check-in counter.",
        tip: "Cruise lines serving Seattle typically require 6 months of passport validity beyond the return date, even for closed-loop Alaska cruises. Check your entire family's passports the moment you book — not the week before departure.",
      },
      {
        icon: "ri-building-2-line",
        title: "Amazon, Microsoft & Boeing — Global Corporate Travel",
        subtitle: "Three of the world's largest employers driving constant international travel",
        description: "Amazon employs 55,000+ in Seattle, Microsoft has 50,000+ in Redmond, and Boeing's commercial airplanes division is headquartered here. These three companies alone generate more international business travel than most mid-size countries. Engineering teams fly to Bangalore, PMs sprint to Tokyo, and supply chain managers deploy to Boeing's global manufacturing sites — often with 5–10 days notice. Standard passport processing cannot keep pace with Seattle's corporate travel tempo.",
        tip: "Amazon and Microsoft employees on H-1B or L-1 visas often need passport renewals in addition to visa stamps. Start the passport renewal process 3+ months before your visa stamping appointment to avoid cascading delays.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "University of Washington — Research & Study Abroad",
        subtitle: "UW's 50,000+ students and global research footprint",
        description: "The University of Washington is one of the world's top research universities with extensive global partnerships. UW sends thousands of students abroad annually through 400+ study abroad programs in 65+ countries. Faculty researchers deploy to field sites across Asia, Africa, and South America. Conference travel for academic presentations is booked months in advance — but passport validity checks often happen at the last minute.",
        tip: "UW students applying for study abroad programs should start their passport application at least 10 weeks before the program start date. First-time applicants must visit an acceptance facility — we guide students through the nearest UW-area facility.",
      },
    ],
    callout: {
      icon: "ri-global-line",
      title: "Seattle's Deep Asia-Pacific Ties & the Visa Overlap Problem",
      description: "Seattle has one of the strongest Asia-Pacific connections of any U.S. city. The region's large Vietnamese, Chinese, Filipino, Korean, Japanese, and Indian communities drive constant family travel to Asia. Many of these trips require both passport renewal and visa applications — and visa processing for India or China adds 2–4 weeks. Start passport renewal 3 months before you need to apply for a visa.",
    },
  },
  destinations: {
    title: "Where Seattle Travelers Go — And Why Passports Get Urgent",
    intro: "Seattle's tech, cruise, and Asia-Pacific connections create distinct international travel patterns with unique urgency triggers.",
    stats: [
      { stat: "42%", label: "of Seattle expedited requests are corporate/tech-related with under 2 weeks notice" },
      { stat: "May–Sep", label: "peak season when Alaska cruise departures, tech travel, and summer vacation overlap" },
      { stat: "1–3 Weeks", label: "average lead time from trip booking to international departure for tech workers" },
      { stat: "24 Hours", label: "shortest turnaround for a cruise passenger departing from Pier 66 to Alaska" },
    ],
    destinations: [
      { name: "Japan & South Korea", context: "Delta SEA→Tokyo/Seoul multiple daily nonstops, Amazon AWS and Microsoft Azure Asia-Pacific teams, Nintendo/Pokémon Company partnerships", urgency: "Tech sprint and launch travel booked 1–2 weeks out", icon: "ri-map-pin-2-line" },
      { name: "India", context: "Amazon and Microsoft offshore engineering teams, Seattle's growing South Asian tech workforce, family visits to Hyderabad and Bangalore", urgency: "Visa + passport timelines overlap — start early", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Ireland", context: "SEA→London nonstop, Amazon AWS London offices, Microsoft Research Cambridge, Boeing supplier relationships", urgency: "Quarterly business reviews booked 2–3 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Vancouver BC weekend trips (2.5-hour drive), Toronto business travel, Whistler ski culture, cross-border Amazon offices", urgency: "Year-round cross-border travel — not seasonal tourism", icon: "ri-map-pin-2-line" },
      { name: "China", context: "Amazon and Microsoft supplier relationships, Boeing 737 MAX deliveries, Seattle's large Chinese-American community", urgency: "Visa processing takes 2–4 weeks — start passport renewal first", icon: "ri-map-pin-2-line" },
      { name: "Germany & Netherlands", context: "SEA→Amsterdam/Frankfurt nonstops, Boeing/Airbus supply chain, Microsoft and Amazon European HQs", urgency: "Industry trade shows and supplier meetings on fixed dates", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Washington Service Areas",
    crossLinksDesc: "We serve travelers across the Evergreen State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Bellevue", route: "/cities/bellevue" },
      { name: "Tacoma", route: "/cities/tacoma" },
      { name: "Spokane", route: "/cities/spokane" },
    ],
  },
  photoLocations: [
    { name: "Walgreens — Capitol Hill", address: "1601 E Madison St, Seattle, WA 98122", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Bartell Drugs — U District", address: "4327 University Way NE, Seattle, WA 98105", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Downtown Seattle", address: "1915 3rd Ave, Seattle, WA 98101", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Belltown", address: "2215 5th Ave, Seattle, WA 98121", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "WA DOL — Seattle Downtown", address: "500 4th Ave, Seattle, WA 98104", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Washington Department of Licensing for driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended.", featured: true },
    { name: "WA DOL — Ballard", address: "5604 22nd Ave NW, Seattle, WA 98107", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Ballard, Fremont, and north Seattle. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "14 miles south of downtown Seattle via I-5",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "Primary airport for Seattle and the Pacific Northwest. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines hub.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Flight Info",
      featured: true,
    },
    {
      code: "BFI",
      name: "King County International Airport (Boeing Field)",
      distance: "Approximately 6 miles south of downtown Seattle",
      address: "7277 Perimeter Rd S, Seattle, WA 98108",
      note: "General aviation and cargo airport. Serves Boeing and corporate aviation. Not typically used for international passenger travel.",
      flightUrl: "https://www.kingcounty.gov/depts/transportation/kcia.aspx",
      flightLabel: "BFI Info",
      featured: false,
    },
    {
      code: "PAE",
      name: "Paine Field (Snohomish County)",
      distance: "Approximately 25 miles north of Seattle via I-5",
      address: "3220 100th St SW, Everett, WA 98204",
      note: "Commercial flights to select domestic destinations. Alaska Airlines and United serve Paine Field. Convenient for North Sound residents.",
      flightUrl: "https://www.painefield.com/",
      flightLabel: "PAE Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Washington State Department of Health. Online, mail, or in-person options available. King County birth records can also be ordered through the King County Vital Records office.",
      url: "https://doh.wa.gov/licenses-permits-and-certificates/vital-records"
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the Washington State Department of Health Vital Records. Required for estate, legal, and survivor benefit matters.",
      url: "https://doh.wa.gov/licenses-permits-and-certificates/vital-records"
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage records from the King County Recorder's Office. Required for name change passport applications. Serving Seattle and all of King County.",
      url: "https://kingcounty.gov/en/dept/records-elections/recorders-office/marriage-licensing"
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the King County Superior Court Clerk. Required for name change passport corrections and legal documentation.",
      url: "https://kingcounty.gov/en/dept/kcsc"
    }
  ],
};